import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import Hero2 from '../../components/hero2/Hero2';
import About2 from '../../components/about2/about2';
import GetquateSection from '../../components/GetquateSection/GetquateSection';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg'

const HomePage2 = () => {
    return (
        <Fragment>
            <SEO title="Anasayfa" />
            <NavbarS2 hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <Hero2 hclass={'wpo-hero-slider'} />
            <About2 hclass={'about-section-s3 section-padding'} />
            <GetquateSection />
            {/* <ServiceSection hclass={'service-section-s2 section-padding'} /> */}
            {/* <Testimonial hclass={'testimonial-section-s2 section-padding'} /> */}
            {/* <PartnerSection hclass={'partner-section-s2 section-padding'} /> */}
            {/* <BlogSection hclass={'blog-section-s2 section-padding'} /> */}
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage2;